import {registerComponent} from '@helpers/vue'

import router from './router'
import PowerBiModuleRoot from './PowerBiModuleRoot'

registerComponent(PowerBiModuleRoot, 'power-bi', {router})
